import { render, staticRenderFns } from "./LastHistory.vue?vue&type=template&id=f995f19c"
import script from "./LastHistory.vue?vue&type=script&lang=js"
export * from "./LastHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports